import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteNationalitySlice = createSlice({
    name: 'VerifyAndDeleteNationality',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteNationality.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteNationality.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteNationality.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteNationality , setStatus} = getVerifyAndDeleteNationalitySlice.actions;
export default getVerifyAndDeleteNationalitySlice.reducer;

export const fetchVerifyAndDeleteNationality = createAsyncThunk('/getVerifyAndDeleteNationality/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteNationality/${id}`);
    const VerifyAndDeleteNationalityData = res.data;
    return VerifyAndDeleteNationalityData.data;
})